import { IDs } from './IDs';

export function getStandorte(data: any): any[] {
    const standorttypen: number[] = [5, 6]; // Veranstaltungen

    return ((data || {})[IDs.ENT_STANDORT] || [])
        .filter((standort: any) =>
            ((+standort.energiedaten_erfassen_orig || +standort.energiedaten_erfassen) === 1)
            && ((typeof standort.standort_typ_tid_orig === 'number' && standorttypen.indexOf(standort.standort_typ_tid_orig) === -1)
                || (typeof standort.standort_typ_tid === 'number' && standorttypen.indexOf(standort.standort_typ_tid) === -1)
            )
        )
        .sort((a: any, b: any) => (+(+a.standort_typ_tid_orig !== 1) - +(+b.standort_typ_tid_orig !== 1)) || (a.name > b.name));
}
